import { UnauthorizedPageStore } from '@/stores/pages/UnauthorizedPageStore';

import { AnalysesStore } from './AnalysesStore';
import { AnalysisExecutionsStore } from './AnalysisExecutionsStore';
import { FastModeStore } from './FastModeStore';
import { NotificationsStore } from './NotificationsStore';
import { OrganizationsStore } from './OrganizationsStore';
import { QueryParamsStore } from './QueryParamsStore';
import { SessionStore } from './SessionStore';

export class RootStore {
  readonly notificationsStore = new NotificationsStore();
  readonly analysesStore = new AnalysesStore();
  readonly analysisExecutionsStore: AnalysisExecutionsStore;
  readonly queryParamsStore = new QueryParamsStore();
  readonly fastModeStore = new FastModeStore();
  readonly sessionStore: SessionStore;
  readonly organizationsStore: OrganizationsStore;
  readonly unauthorizedPageStore: UnauthorizedPageStore;

  constructor() {
    this.sessionStore = new SessionStore();
    this.unauthorizedPageStore = new UnauthorizedPageStore(this.sessionStore);
    this.analysisExecutionsStore = new AnalysisExecutionsStore({
      analysesStore: this.analysesStore,
      notificationsStore: this.notificationsStore,
      fastModeStore: this.fastModeStore,
    });
    this.organizationsStore = new OrganizationsStore(this.notificationsStore);
  }
}
